import React from 'react';
import PropTypes from 'prop-types';

import Container from '../../../../layout/container/container';
import Headline from '../../../../atoms/headline/headline';
import Copy from '../../../../atoms/copy/copy';
import Image from '../../../../atoms/image/image';
import StepIcon from '../../svgs/icons/floorPlanStep.svg';

import StyledWaitingLayer from './waitingLayer.style';

const randomFactIndex = Math.floor(Math.random() * 3);

const WaitingLayer = ({
  headline,
  facts,
  subline = '',
  sublineTreasure = '',
  additionalInformation = '',
  variant
}) => (
  <StyledWaitingLayer variant={variant}>
    <Container>
      {variant === 'normal' && (
        <div className="content">
          <div className="steps">
            <StepIcon />
            <StepIcon />
          </div>
          <Copy>{subline}</Copy>
          <Headline primary>{headline}</Headline>
          <Copy thick noMargin>
            {additionalInformation}
          </Copy>
          <Copy>{facts[randomFactIndex]}</Copy>
          <div className="steps">
            <StepIcon />
            <StepIcon />
          </div>
          <div className="steps">
            <StepIcon />
            <StepIcon />
          </div>
        </div>
      )}

      {variant === 'treasure' && (
        <>
          <div className="content">
            <Copy>{sublineTreasure}</Copy>
            <Headline primary>{headline}</Headline>
            <Copy thick noMargin>
              {additionalInformation}
            </Copy>
            <Copy>{facts[randomFactIndex]}</Copy>
          </div>
          <div className="robotarm">
            <div className="robotarm-wrapper">
              <Image src="/static/images/robotarm.gif" />
            </div>
          </div>
        </>
      )}
    </Container>
  </StyledWaitingLayer>
);

WaitingLayer.propTypes = {
  headline: PropTypes.string.isRequired,
  additionalInformation: PropTypes.string,
  facts: PropTypes.arrayOf(PropTypes.string).isRequired,
  subline: PropTypes.string,
  sublineTreasure: PropTypes.string,
  variant: PropTypes.oneOf(['normal', 'treasure']).isRequired
};

export default WaitingLayer;
